import { render, staticRenderFns } from "./UserMyCultures.vue?vue&type=template&id=cfb68fc6&"
import script from "./UserMyCultures.vue?vue&type=script&lang=js&"
export * from "./UserMyCultures.vue?vue&type=script&lang=js&"
import style0 from "./UserMyCultures.vue?vue&type=style&index=0&id=cfb68fc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports